/* eslint-disable @typescript-eslint/no-explicit-any */

import localforage from 'localforage';

export interface Cache {
  setItem<T = unknown>(key: string, value: T): Promise<void>;
  getItem<T = unknown>(key: string): Promise<T | null>;
  removeItem(key: string): Promise<void>;
  clear(): Promise<void>;
}

class LocalCacheImpl implements Cache {
  private instance: LocalForage;

  constructor(name?: string) {
    this.instance = name
      ? localforage.createInstance({
          name,
        })
      : localforage;
  }

  public async setItem<T = unknown>(key: string, value: T): Promise<void> {
    this.instance.setItem(key, value);
  }

  public async getItem<T = unknown>(key: string): Promise<T | null> {
    return this.instance.getItem(key);
  }

  public async removeItem(key: string): Promise<void> {
    this.instance.removeItem(key);
  }

  public async clear(): Promise<void> {
    this.instance.clear();
  }
}

const localCache = new LocalCacheImpl();

export { localCache };
